import { Component } from "@angular/core";
import { environment } from "../../../../environments/environment";

@Component({
  standalone: true,
  selector: "vig-footer",
  templateUrl: "./footer.component.html",
  styleUrl: "./footer.component.scss",
  imports: [],
})
export class FooterComponent {
  environmentName = environment.environmentName;
  buildVersion = environment.buildVersion;
}
